import {inject, injectable} from "inversify";
import type {IHttpClientService, IApiResponse} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {IFriendsResponse} from "data/types/h2h";
import {IFriend} from "data/stores/friends/friends.store";

export interface IFriendsApiProvider {
	friends: () => Promise<AxiosResponse<IApiResponse<IFriendsResponse>>>;
	friend_invites: () => Promise<AxiosResponse<IApiResponse<IFriendsResponse>>>;
	search: (code: string) => Promise<AxiosResponse<IApiResponse<{friend: IFriend}>>>;
	invite: (friendId: number) => Promise<AxiosResponse<IApiResponse>>;
	invite_by_code: (friendCode: string) => Promise<AxiosResponse<IApiResponse>>;
	delete: (friendId: number) => Promise<AxiosResponse<IApiResponse>>;
	accept: (friendId: number) => Promise<AxiosResponse<IApiResponse>>;
	// play: (friendId: number) => Promise<AxiosResponse<IApiResponse<{friend: IFriend}>>>;
}

/*
POST	/friend/{friendId<\d+>}/invite	Invite friend by ID
POST	/friend/{code<[\w\d]+>}/invite-by-code	Invite friend by code
POST	/friend/{friendId<\d+>}/view	Mark friend invitation message as viewed
POST	/friend/{friendId<\d+>}/accept	Accept friend invitation
POST	/friend/{friendId<\d+>}/delete
 */
@injectable()
export class FriendsApiProvider implements IFriendsApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	public friends = () => {
		return this._http.get<IApiResponse<IFriendsResponse>>(`friends`);
	};

	public friend_invites = () => {
		return this._http.get<IApiResponse<IFriendsResponse>>(`friend/invitations`);
	};

	public search = (code: string) => {
		return this._http.get<IApiResponse<{friend: IFriend}>>(`friend/${code}/search`);
	};

	public invite = (friendId: number) => {
		return this._http.post<IApiResponse>(`friend/${friendId}/invite`);
	};

	public invite_by_code = (friendCode: string) => {
		return this._http.post<IApiResponse>(`friend/${friendCode}/invite-by-code`);
	};

	public delete = (friendId: number) => {
		return this._http.post<IApiResponse>(`friend/${friendId}/delete`);
	};
	public accept = (friendId: number) => {
		return this._http.post<IApiResponse>(`friend/${friendId}/accept`);
	};
}
